import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear'
import { VBtn } from 'vuetify/lib/components/VBtn'
import { VContainer, VRow, VCol } from 'vuetify/lib/components/VGrid'
import { VApp } from 'vuetify/lib/components/VApp'
import { VTextarea } from 'vuetify/lib/components/VTextarea'

Vue.use(Vuetify, {
    components: {
        VProgressLinear,
        VBtn,
        VRow,
        VContainer,
        VCol,
        VApp,
        VTextarea
    },
    icons: {
        iconfont: 'faSvg',
    },
})

export default new Vuetify({});
